import { render, staticRenderFns } from "./control-font-family.vue?vue&type=template&id=43e7e737&"
import script from "./control-font-family.vue?vue&type=script&lang=js&"
export * from "./control-font-family.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports